/* eslint-disable no-console */
import { LogLevel } from '../enum/index';
import { formatLogOutput } from './utils';
export class FlagshipLogManager {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    consoleError;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    consoleWarn;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    consoleDebug;
    constructor() {
        this.consoleError = console.error ?? console.log;
        this.consoleWarn = console.warn ?? console.log;
        this.consoleDebug = console.debug ?? console.log;
    }
    emergency(message, tag) {
        this.consoleError(formatLogOutput(LogLevel.EMERGENCY, message, tag));
    }
    alert(message, tag) {
        this.consoleError(formatLogOutput(LogLevel.ALERT, message, tag));
    }
    critical(message, tag) {
        this.consoleError(formatLogOutput(LogLevel.CRITICAL, message, tag));
    }
    error(message, tag) {
        this.consoleError(formatLogOutput(LogLevel.ERROR, message, tag));
    }
    warning(message, tag) {
        this.consoleWarn(formatLogOutput(LogLevel.WARNING, message, tag));
    }
    notice(message, tag) {
        this.log(LogLevel.NOTICE, message, tag);
    }
    info(message, tag) {
        console.info(formatLogOutput(LogLevel.INFO, message, tag));
    }
    debug(message, tag) {
        this.consoleDebug(formatLogOutput(LogLevel.DEBUG, message, tag));
    }
    log(level, message, tag) {
        console.log(formatLogOutput(level, message, tag));
    }
}
